module.exports = require("@glidejs/glide");